import { extendTheme } from "@chakra-ui/react"

const theme = extendTheme({
  variants: {
    h1: {
      as: "h1",
      fontSize: "62px",
      lineHeight: "76px",
      letterSpacing: "-0.01em",
      fontFamily: "riforma.medium",
      fontWeight: 500,
    },
    h2: {
      as: "h2",
      fontSize: "48px",
      lineHeight: "56px",
      letterSpacing: "-0.01em",
      fontFamily: "riforma.medium",
      fontWeight: 500,
    },
    h3: {
      as: "h3",
      fontSize: "26px",
      lineHeight: "32px",
      fontFamily: "riforma.medium",
      fontWeight: 500,
    },
    h4: {
      as: "h4",
      fontSize: "18px",
      lineHeight: "24px",
      fontFamily: "riforma.medium",
      fontWeight: 500,
    },
    h5: {
      as: "h5",
      fontSize: "18px",
      lineHeight: "24px",
      fontFamily: "riforma.black",
      fontWeight: 900,
    },
    hero: {
      as: "h1",
      fontSize: "80px",
      lineHeight: "84px",
      fontFamily: "riforma.medium",
      fontWeight: 500,
    },
  },
})

export default theme
